import { MutableRefObject, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import Alert from '@mui/material/Alert';
import Portal from '@mui/material/Portal';

const Wrapper = ({
  hasPurchasedRecently = false,
  children = null,
  container = null,
}: PropsWithChildren<{
  container?: MutableRefObject<HTMLElement | null> | null;
  hasPurchasedRecently?: boolean;
}>) => {
  const { t } = useTranslation('site');

  return (
    <>
      {hasPurchasedRecently && container && (
        // @ts-ignore
        <Portal container={container.current}>
          <Alert data-testid="alert-banner" severity="warning">
            {t(`advancedServer.alerts.serverStatus.description`)}
          </Alert>
        </Portal>
      )}
      {children}
    </>
  );
};

export default Wrapper;
